<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/absen-list-custom">Daftar Absensi</a>
        </li>
        <!-- <li class="breadcrumb-item">
          <a href="#/absen-list-custom?action=input">Input Absensi</a>
        </li> -->

        <li class="breadcrumb-item active" aria-current="page">
          Import Absensi
        </li>
      </ol>
    </nav>

    <h5 class="content-block">Import Absensi</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <dl class="row">
          <dt class="col-sm-2">Periode Absensi:</dt>
          <dt class="col-sm-10">
            <DxDateBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :input-attr="{ 'aria-label': 'Periode Absensi' }"
              display-format="MMMM yyyy"
              type="date"
              picker-type="calendar"
              :open-on-field-click="true"
              :calendar-options="{
                maxZoomLevel: 'year',
                minZoomLevel: 'year',
              }"
              label="Periode Absensi"
              placeholder="Pilih Periode Absensi"
              v-model="tgl"
            />
          </dt>
        </dl>

        <dl class="row">
          <dt class="col-sm-2">Download Template Import:</dt>
          <dt class="col-sm-10">
            <DxButton
              icon="download"
              text="Download"
              ref="fileDownloader"
              @click="downloadPegawai"
              styling-mode="outlined"
            />
          </dt>
        </dl>
        <dl class="row">
          <dt class="col-sm-2">Import file excel data pegawai</dt>
          <dt class="col-sm-10">
            <input type="file" ref="fileInput" @change="handleFile" />
          </dt>
        </dl>
      </div>
    </div>
    <!-- <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Absensi</p>
        <div class="row">
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <dx-popup
          :visible="popupLoadingVisible"
          title="Simpan data & sinkronisasi gaji..."
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="330"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </dx-popup>

        <dx-popup
          v-if="tgl"
          :visible="isDeleteDialogVisible"
          title="Konfirmasi Simpan Absen"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          width="300"
          :height="170"
        >
          <div>
            Simpan Absen ini di bulan
            <strong>{{ formattedTgl }} </strong>?<br />
            Data absensi lama di bulan yang sama akan <strong>dihapus!</strong>
          </div>
          <!-- <div class="buttons">
            <dx-button text="Cancel" @click="cancelDelete" />
            <dx-button text="Delete" @click="confirmDelete" />
          </div> -->
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="cancelButtonOptions"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="saveButtonOptions"
          />
        </dx-popup>

        <DxDataGrid
          ref="dataGrid"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="pegawai_id"
          @editor-preparing="oneditorpreparing"
          @editing-start="editingStart"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :focused-row-enabled="true"
          :focused-row-index="0"
          @option-changed="onPageChanged($event, 'dataGrid')"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />

          <DxEditing
            :allow-updating="can('absensi-update')"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>

          <DxToolbar> </DxToolbar>

          <DxColumnFixing :enabled="true" />
          <DxColumn
            caption="#"
            data-field="created_at"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :fixed="true"
            fixed-position="left"
            :allow-edititng="false"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn
            data-field="nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allow-edititng="false"
          />
          <DxColumn
            data-field="nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
            :min-width="200"
            :allow-edititng="false"
          />

          <!-- <DxColumn data-field="cabang_nama" caption="Cabang" />
          <DxColumn data-field="unit_nama" caption="Unit" />
          <DxColumn data-field="jabatan_nama" caption="Jabatan" />
          <DxColumn data-field="pegawai_status_nama" caption="Status Pegawai" />
          <DxColumn data-field="bagian_nama" caption="Bagian" />
          <DxColumn data-field="sub_bagian_nama" caption="Sub Bagian" />
          <DxColumn data-field="bidang_nama" caption="Bidang" /> -->
          <!-- <DxColumn data-field="sub_bidang_nama" caption="Sub Bidang" />
          <DxColumn data-field="seksi_nama" caption="Seksi" /> -->
          <DxColumn
            data-field="jabatan"
            caption="Jabatan"
            :allow-edititng="false"
          />
          <DxColumn data-field="hadir" caption="Hadir" />
          <DxColumn
            data-field="sakit"
            caption="Sakit"
            data-type="number"
            :set-cell-value="setCellValueSakit"
          />
          <DxColumn
            data-field="ijin"
            caption="Ijin"
            data-type="number"
            :set-cell-value="setCellValueIjin"
          />
          <DxColumn
            data-field="alpa"
            caption="Alpa"
            data-type="number"
            :set-cell-value="setCellValueAlpa"
          />
          <DxColumn
            :allow-edititng="false"
            data-field="tidak_hadir"
            data-type="number"
            caption="Tidak Hadir"
            css-class="cell-highlighted"
            :set-cell-value="setCellValueTidakHadir"
          />
          <DxSummary>
            <DxTotalItem
              column="created_at"
              summary-type="count"
              value-format="#,##0"
            />
            <DxTotalItem
              column="hadir"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="sakit"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="ijin"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="alpa"
              summary-type="sum"
              value-format="#,##0"
            />

            <DxTotalItem
              column="tidak_hadir"
              summary-type="sum"
              value-format="#,##0"
            />
          </DxSummary>
        </DxDataGrid>
        <DxButton
          @click="showDeleteDialog()"
          text="Simpan"
          type="default"
          class="validate"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import can from "@/haspermission";
import auth from "@/auth";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import DxButton from "devextreme-vue/button";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DateTime } from "luxon";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import axios from "axios";
import notify from "devextreme/ui/notify";
// import DxSelectBox from "devextreme-vue/select-box";
import router from "@/router";
import DxDateBox from "devextreme-vue/date-box";
// import ODataStore from "devextreme/data/odata/store";
// import DataSource from "devextreme/data/data_source";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxColumnFixing,
  DxToolbar,
  // DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  // DxItem,
} from "devextreme-vue/data-grid";
import { useDukListStore } from "@/stores/views/duk-list-store";
import * as XLSX from "xlsx";
import { ref } from "vue";
const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [Number(currentYear) - 1, currentYear, Number(currentYear) + 1];
const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];
const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];
export default {
  components: {
    DxButton,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxColumnFixing,
    DxToolbar,
    // DxButtonDatagrid,
    // DxSelectBox,
    DxPopup,
    DxToolbarItem,
    DxDropDownButton,
    DxSummary,
    DxTotalItem,
    DxDateBox,
  },
  setup() {
    const dukListStore = useDukListStore();
    const tgl = ref(DateTime.now().set({ day: 1 }).toISODate());
    // diklatListStore.dataSourcePeringatanList.filter(null);
    return {
      dukListStore,
      tgl,
      can,
    };
  },

  data() {
    return {
      popupLoadingVisible: false,
      options: options,
      isDeleteDialogVisible: false,
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
      },

      file: null,
      imageUrl: require("@/views/template_import_pegawai.png"),
      dataSource: null,
      numberingPageSize: 10,
      numberingPageNumber: 0,
      bulanSource: months,
      tahunSource: years,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      cancelButtonOptions: {
        text: "Cancel",
        type: "danger",
        onClick: () => {
          this.isDeleteDialogVisible = false;
        },
      },

      saveButtonOptions: {
        text: "Simpan Absen",
        type: "default",
        onClick: () => {
          //tambahkan ijazahfile ke array
          // this.ijazahFilePrep();
          this.isDeleteDialogVisible = false;
          this.dataGridSave();
        },
      },
    };
  },
  computed: {
    formattedTgl() {
      // Use DateTime from luxon to format tgl
      if (!this.tgl) return "";
      return DateTime.fromISO(this.tgl).toFormat("MMMM yyyy");
    },
  },
  mounted() {},
  methods: {
    editingStart(e) {
      if (
        e.column.dataField === "hadir" ||
        e.column.dataField === "sakit" ||
        e.column.dataField === "ijin" ||
        e.column.dataField === "alpa" ||
        e.column.dataField === "cuti" ||
        e.column.dataField === "libur"
      ) {
        e.cancel = false;
      } else {
        e.cancel = true;
      }
    },
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },

    printBulan(id) {
      return this.bulanSource.find((g) => g.id === id).name;
    },
    showDeleteDialog() {
      this.isDeleteDialogVisible = true;
    },
    onDeleteDialogHidden() {
      // This method is called when the dialog is closed
      // You can perform additional actions if needed
    },
    cancelDelete() {
      this.isDeleteDialogVisible = false;
      // Additional actions on cancel
    },
    confirmDelete() {
      this.isDeleteDialogVisible = false;
      // Additional actions on delete
    },

    detailPegawai(e) {
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");

      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
    },
    async dataGridSave() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      this.dataSource.forEach((row) => {
        row.libur = row.libur_cuti_bersama;
        delete row.libur_cuti_bersama;
      });

      var data = {
        periode_absen: DateTime.fromISO(this.tgl).set({ day: 1 }).toISODate(),
        created_by_user_id: auth.getUser().id,
        updated_by_user_id: auth.getUser().id,
        data: this.dataSource,
        method: "absen_bulans",
      };

      this.popupLoadingVisible = true;
      await axios
        .post(`${API_BASE_URL}/absen_bulan_import`, data, config)
        .then((response) => {
          this.popupLoadingVisible = false;
          notify(response.data.message, "success");

          router.push({
            name: "absen-list-custom",
          });
        })
        .catch((error) => {
          this.popupLoadingVisible = false;
          notify("Gagal import absen pegawai " + error, "error");
        });
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    setCellValueAlpa(newData, value, currentRowData) {
      newData.alpa = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.sakit);
      // +this.nullOrZero(currentRowData.libur);
    },
    setCellValueIjin(newData, value, currentRowData) {
      newData.ijin = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa);
      // +this.nullOrZero(currentRowData.libur);
    },
    setCellValueSakit(newData, value, currentRowData) {
      newData.sakit = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.alpa);
    },

    nullOrZero(num) {
      if (num === null) return 0;
      return parseInt(num);
    },

    oneditorpreparing(e) {
      // if (e.parentType !== "filterRow") e.editorOptions.disabled = true;

      if (
        e.parentType === "dataRow" &&
        (e.dataField === "hadir" ||
          e.dataField === "sakit" ||
          e.dataField === "ijin" ||
          e.dataField === "alpa" ||
          e.dataField === "cuti" ||
          e.dataField === "libur")
      ) {
        e.editorOptions.disabled = false;
      } else if (e.parentType === "dataRow") {
        e.editorOptions.disabled = true;
      }
      return;
    },

    async handleFile(e) {
      // console.log(_.find(this.seksis, { id: 1 }));
      const files = e.target.files;
      const file = files[0];
      this.file = file;
      const self = this;
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: "binary",
          cellText: false,
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        this.data = XLSX.utils.sheet_to_json(worksheet, {});
        self.dataSource = this.data;
        // console.log(this.data);
      };

      reader.readAsBinaryString(file);
    },

    async downloadPegawai() {
      const dataDuk = await this.dukListStore.getData([
        ["tgl", "=", this.tgl],
        ["capeg_tetap", "=", false],
        ["include_direksi", "=", true],
      ]);

      const exportData = dataDuk.data.map((duk) => ({
        pegawai_id: duk.id,
        riwayat_pekerjaan_id:
          duk.riwayat_pekerjaans && duk.riwayat_pekerjaans[0]
            ? duk.riwayat_pekerjaans[0].id
            : null,
        nik: duk.nik,
        nama: duk.nama,
        jabatan:
          duk.riwayat_pekerjaans && duk.riwayat_pekerjaans[0]
            ? duk.riwayat_pekerjaans[0].jabatan_print
            : "",
        hadir: 0,
        sakit: 0,
        ijin: 0,
        alpa: 0,
        tidak_hadir: 0,
      }));

      const data = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "Import Absen - data pegawai jgn diubah.xlsx");

      // let dataFin = JSON.stringify(data);
      // var data = {
      //   // tahun: currentYear,
      //   // bulan: currentMonth,
      //   //ga perlu post tahun/bulan karena otomatis dianggap adalah current month n year
      //   method: "absen_bulans",
      // };

      // await axios
      //   .post(`${API_BASE_URL}/get_pegawai`, data, config)
      //   .then((response) => {
      //     console.log("test", response);
      //     notify(response.data.message, response.data.notify_type);
      //     if (response.data.status) {
      //       const data = XLSX.utils.json_to_sheet(response.data.data);
      //       const wb = XLSX.utils.book_new();
      //       XLSX.utils.book_append_sheet(wb, data, "data");
      //       XLSX.writeFile(wb, "Import Absen - data pegawai jgn diubah.xlsx");
      //     }
      //   })
      //   .catch((error) => {
      //     notify("Gagal download file pegawai " + error, "error");
      //   });
    },
  },
};
</script>
